export const bespokeBillingInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: false, hidden: true };

    if (campaign?.billingTermName === 'Bespoke') {
        state.hidden = false;
    }

    if (campaign?.invoices?.length) {
        state.stepEdited = true;
    }

    // ToDo: add any further checks required

    return state;
};

export const sumLines = (invoice, field) => {
    let total = 0;
    invoice?.billingPlanInvoiceLines?.forEach((il, i) => {
        total = total + parseFloat(il[field]);
    });

    return total;
};

export const sumBillingPlanLines = (invoice, field) => {
    let total = 0;
    invoice?.billingPlanInvoiceLines?.forEach((il, i) => {
        total = total + parseFloat(il[field]);
    });

    return total;
};

export const sumAllLines = (invoices, field) => {
    let total = 0;
    invoices?.forEach((i) => {
        i.billingPlanInvoiceLines?.forEach((il, i) => {
            total = total + parseFloat(il[field]);
        });
    });

    return total;
};

export const sumAllBillingPlanLines = (invoices, field) => {
    let total = 0;
    invoices?.forEach((i) => {
        i.billingPlanInvoiceLines?.forEach((il, i) => {
            total = total + parseFloat(il[field]);
        });
    });

    return total;
};
